import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next'
import { ContractDetailList } from './ContractDetailList'
import { CustomTable } from '../CustomTable/CustomTable';
import { EmptyStateOne } from '../Empty/EmptyStateOne';

export const ContractsDetailModal = ({ resource = '', contracts = [], showModal, setShowModal }) => {

    const tableHeaders = [
        { key: t('CODE') },
        { key: t('DESCRIPTION') },
        { key: t('OPENING') },
        { key: t('DATE_SINCE') },
        { key: t('DATE_UNTIL') },
    ]

    const noContractsText = {
        EMP: 'EMP_HAS_NOT_CONTRACTS_ASSIGNED',
        VEH: 'VEH_HAS_NOT_CONTRACTS_ASSIGNED',
    }

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
            title={t("CONTRACTS_DETAILS")}
            backgroundColor='var(--gray-50)'
        >
            <div>

                {
                    contracts.length > 0 ? (
                        <div className='table-responsive'>

                            <CustomTable headers={tableHeaders} id={'contractsDetailsTable'}>

                                {contracts.map((contract) =>
                                    <ContractDetailList
                                        key={contract.idCONTRATO}
                                        contract={contract}
                                    />
                                )}

                            </CustomTable>

                        </div>
                    )
                        :
                        <EmptyStateOne
                            message={
                                t(`${noContractsText[resource]}`)
                            }
                        />
                }

            </div>
        </CustomModal>
    )
}
